import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-pad",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-pad.component.html",
  styleUrl: "./prefix-pad.component.less",
})
export class PrefixPadComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 200;
    this.characters = ALLOWED_CHARACTERS["pad"];
  }
}
